import * as React from 'react';
import { useShouldShowNewOrgOverview } from '@/utils/internalFeatureFlags';
import { selectOrg } from '@/selectors/selectors';
import { RootState } from '@/reducers/reducers';
import type { OrgComponentProps } from '@/typescriptHelpers';
import { useSelector } from 'react-redux';
import OrgOverviewV2 from './OrgOverviewV2';
import OrgOverview from './OrgOverview';

export const OrgOverviewRoute: React.FC<OrgComponentProps> = (props: OrgComponentProps) => {
    const org = useSelector((state: RootState) => selectOrg(state, props.orgId));
    const shouldShowNewOrgOverview = useShouldShowNewOrgOverview(org);

    if (shouldShowNewOrgOverview) {
        return <OrgOverviewV2 {...props} />;
    }

    return <OrgOverview {...props} />;
};
